var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activity Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90671 0C3.13393 0 3.31812 0.184195 3.31812 0.41141V8.31048C3.31812 8.5377 3.13393 8.72189 2.90671 8.72189C2.6795 8.72189 2.4953 8.5377 2.4953 8.31048V0.41141C2.4953 0.184195 2.6795 0 2.90671 0Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602816 3.62041C0.830032 3.62041 1.01423 3.8046 1.01423 4.03182V8.31048C1.01423 8.5377 0.830032 8.72189 0.602816 8.72189C0.375601 8.72189 0.191406 8.5377 0.191406 8.31048V4.03182C0.191406 3.8046 0.375601 3.62041 0.602816 3.62041Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62202 2.71531C5.62202 2.48809 5.43783 2.3039 5.21061 2.3039C4.98339 2.3039 4.7992 2.48809 4.7992 2.71531V8.31048C4.7992 8.5377 4.98339 8.72189 5.21061 8.72189C5.43783 8.72189 5.62202 8.5377 5.62202 8.31048V2.71531Z",
    fill: "#777777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterActivity);
export default __webpack_public_path__ + "static/media/twitterActivity.f845a74e1abe03f70569d1151abaf865.svg";
export { ForwardRef as ReactComponent };